import PatientForm from "../Pages/Patients/PatientForm/PatientForm";

export const publicRoutes = [
  { path: "/patient-form", Component: <PatientForm /> },
];
